// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTouch from 'vue-touch'
import { Lazyload } from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'

Vue.config.productionTip = false
// axios.interceptors.response.use(function (response) {
//   console.log("response: ", response);
//   if (response.headers['conent-type'] === "application/octet-stream") {
//     response.headers['content-type'] === "application/json;charset=UTF-8";
//   }
//   return response;
// })
Vue.use(VueAxios, axios)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(Lazyload)

Vue.filter('AmountStr', function (number) {
  return isNaN(number) ? "0.00" : (number / 100).toFixed(2);
})
Vue.filter('FormatTime', function (timestamp) {
  const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n;
  }
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return year + '-' + formatNumber(month) + '-' + formatNumber(day);
})
Vue.filter('FormatPublishTime', function (timestamp) {
  const formatDate = date => {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return formatNumber(month) + "月" + formatNumber(day) + "日";
  }
  const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n;
  }
  if (timestamp == null) return "";
  const date = new Date(timestamp);
  const now = new Date();
  const elapsed_second = (now - date) / 1000;
  if (elapsed_second < 60) {
    return "刚刚";
  } else if (elapsed_second < 60 * 60) {
    return parseInt(elapsed_second / 60) + "分钟前";
  } else if (elapsed_second < 60 * 60 * 24) {
    return parseInt(elapsed_second / 60 / 60) + "小时前";
  } else {
    return formatDate(date);
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js